import * as Dialog from '@radix-ui/react-dialog'
import { cx } from '../util/cx'
import styles from './Overlay.module.css'

interface OverlayProps {
  children: React.ReactNode
  variant?: 'fullscreen' | 'backdrop'
  onClose?: () => void
  ariaLabel?: string
}

export default function Overlay({
  children,
  variant = 'fullscreen',
  onClose,
  ariaLabel,
}: OverlayProps) {
  const isBackdrop = variant === 'backdrop'

  return (
    <Dialog.Root open onOpenChange={(open) => !open && onClose?.()}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={isBackdrop ? styles.backdrop : styles.overlay}
        />
        <Dialog.Content
          className={isBackdrop ? styles.backdropContent : styles.fullscreenContent}
          aria-describedby={undefined}
          onPointerDownOutside={(event) => {
            if (!onClose) event.preventDefault()
          }}
          onEscapeKeyDown={(event) => {
            if (!onClose) event.preventDefault()
          }}
        >
          <Dialog.Title className={styles.srOnly}>
            {ariaLabel ?? (isBackdrop ? 'Dialog' : 'Screen')}
          </Dialog.Title>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export function OverlayCard({ children }: { children: React.ReactNode }) {
  return <div className={styles.card}>{children}</div>
}
